var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "971.05 291.13 540 42.26 108.94 291.13 108.94 788.87 540 1037.74 971.05 788.87 971.05 291.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "971.05 291.13 540 488.39 108.94 291.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 540,
    y1: 1037.74,
    x2: 540,
    y2: 488.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 702.48,
    y1: 500.69,
    x2: 905.53,
    y2: 413.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 240.5,
    y1: 444.8,
    x2: 395.11,
    y2: 517.45
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/ICON_Products.2665f50f4453f62a500b9a58a8b1c59b.svg";
export { ForwardRef as ReactComponent };